"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRequest = useRequest;
exports.requestError = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var reducer = function reducer() {
  return function (state, payload) {
    return _objectSpread(_objectSpread({}, state), payload);
  };
};

var requestError = {
  error: 'Failed request'
};
exports.requestError = requestError;

function useRequest(initLoading) {
  var _useReducer = (0, _react.useReducer)(reducer(), {
    complete: false,
    loading: initLoading || false,
    data: null,
    error: null
  }),
      _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var complete = state.complete,
      loading = state.loading,
      data = state.data,
      error = state.error;

  var handleRequest = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(request) {
      var response, output;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                loading: true
              });
              _context.next = 3;
              return request.catch(function (e) {
                return requestError;
              });

            case 3:
              response = _context.sent;
              output = response && response.error ? response : response;
              dispatch({
                complete: true,
                loading: false,
                data: !response.error ? output : null,
                error: response.error ? output : null
              });
              return _context.abrupt("return", output);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleRequest(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var request = (0, _react.useCallback)(handleRequest, [dispatch]);
  return {
    complete: complete,
    loading: loading,
    data: data,
    error: error,
    request: request
  };
}